import './index.scss'
$(".solution-nav ul li").eq(0).addClass("active");
$(".solution-content ul li").eq(0).addClass("active");
$(".solution-nav ul li").click(function(){
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(".solution-content ul li").eq(index).addClass('active').siblings().removeClass('active');
})
$(".sale-nav ul li").eq(0).addClass("active");
$(".sale-content ul").eq(0).addClass("active");
$(".sale-nav ul li").click(function(){
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(".sale-content ul").eq(index).addClass('active').siblings().removeClass('active');
})
